// vue
import { ref } from '@vue/composition-api';
import store from '@/store';

// libs
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';

// images
import logo from '@/assets/clere-logo-grey.png';

export const useGeoRecordPdf = () => {
    // store
    const schema = store.getters.currentCourseSchema.name;

    // refs
    const isGeneratingPdf = ref(false);

    //methods
    const addFooter = (jspdf) => {
        const pageCount = jspdf.getNumberOfPages();

        jspdf.setFont('helvetica', 'italic');
        jspdf.setFontSize(9);

        for (var i = 1; i <= pageCount; i++) {
            jspdf.setPage(i);
            jspdf.text(
                `${store.state.date} Clere Group Ltd | cleregolfhub.com | info@cleregolf.com`,
                jspdf.internal.pageSize.width / 2,
                jspdf.internal.pageSize.height - 5,
                {
                    align: 'center',
                },
            );
        }
    };

    const addHeader = (jspdf) => {
        var currentDate = new Date();
        let img = new Image();

        const displayName = schema.charAt(0).toUpperCase() + schema.slice(1);
        const date = `${currentDate.getDate()}/${
            currentDate.getMonth() + 1
        }/${currentDate.getFullYear()}`;

        img.src = logo;
        jspdf.addImage(img, 'png', 15, 5, 50, 10);

        jspdf.setFontSize(20);
        jspdf.setFont('times', 'bold');
        jspdf.text('GeoRecord Table', 200, 10, {
            align: 'center',
        });

        jspdf.setFont('times', 'normal');
        jspdf.setFontSize(15);
        jspdf.rect(15, 20, 200, 10);
        jspdf.text('Course Name: ' + displayName, 17, 27);

        jspdf.rect(355, 20, 50, 10);
        jspdf.text('Date: ' + date, 357, 27);

        jspdf.line(14, 34, 405, 34);
    };

    var generateData = (geoRecords, columns) => {
        var result = <any>[];

        geoRecords.forEach((geoRecords) => {
            var eachArr = <any>[];
            columns.forEach((column) => {
                column == 'holes'
                    ? eachArr.push('[' + geoRecords[column] + ']')
                    : eachArr.push(geoRecords[column]);
            });
            result.push(eachArr);
        });
        return result;
    };

    const generatePDf = async (georecords: any, columns: any[]) => {
        if (!isGeneratingPdf.value) {
            let column = <any>[];

            isGeneratingPdf.value = true;

            for (let i = 0; i < columns.length; i++) {
                let columnString = columns[i];
                if (columnString == 'geoRecordCategory') {
                    columnString = 'Category';
                } else if (columnString == 'projectId') {
                    columnString = 'project';
                }
                column.push(columnString.toUpperCase());
            }

            const jspdf = new jsPDF('l', 'mm', 'a3');

            addHeader(jspdf);

            autoTable(jspdf, {
                headStyles: {
                    fillColor: '#81B622',
                    valign: 'middle',
                    halign: 'center',
                },
                head: [column],
                body: generateData(georecords, columns),
                startY: 38,
            });

            addFooter(jspdf);

            let fileName =
                'ClereGolfHub_GeoRecords_' +
                store.getters.currentCourseSchema.name;

            jspdf.save(fileName);
            isGeneratingPdf.value = false;
        }
    };

    return { generatePDf, isGeneratingPdf };
};
